import React from "react";
import { Container } from "react-bootstrap";
import "../styles/Pages/Blogs.scss";
import LatestArticles from "../components/Blogs/LatestArticles";
import BlogsPopularArticles from "../components/Blogs/BlogsPopularArticles";
import SwiperSlider from "../components/Blogs/SwiperSlider";
const Blogs = () => {
  return (
    <Container fluid id="blogs">
      {/* <SwiperSlider /> */}
      <BlogsPopularArticles />
      <LatestArticles />
    </Container>
  );
};

export default Blogs;
